import makeStyles from "@material-ui/core/styles/makeStyles";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import ActionButton from "../../../components/common/ActionButton";
import ActionHeading from "../../../components/common/ActionHeading";
import Container from "../../../components/common/Container";
import HeaderBar from "../../../components/common/HeaderBar";
import PageHeading from "../../../components/common/PageHeading";
import RiskControlVerificationFilters from "../../../components/risk/RiskControlVerificationFilters";
import RiskControlVerificationListing from "../../../components/risk/RiskControlVerificationListing";
import { getLoggedInUser } from "../../../reducers";
import { clearIcon, workItemIcon } from "../../../util/icons";
import useLocationStateFilter from "../../../util/locationStateFilter";
import usePersistedState from "../../../util/persistedState";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  contents: {
    marginBottom: "75px",
  },
}));

const defaultFilter = {
  ownerIds: [],
  subTypes: [],
  outcomes: [],
};

const RiskControlVerificationsListingPage = ({ history, loggedInUser }) => {
  const classes = useStyles();
  const [sortBy, setSortBy] = usePersistedState(
    `risk-control-verification-listing-sort-${loggedInUser.email}`,
    {
      field: "created",
      direction: "desc",
    }
  );
  const [filter, setFilter] = usePersistedState(
    `risk-control-verification-listing-filter-${loggedInUser.email}`,
    defaultFilter,
    ["textSearch"]
  );
  useLocationStateFilter(setFilter, history);

  const clearFilter = () => setFilter({ ...defaultFilter });

  const updateFilter = (key, value) => {
    setFilter({
      ...filter,
      [key]: value,
    });
  };

  return (
    <div className={classes.root}>
      <HeaderBar fluid>
        <ActionHeading
          heading={
            <PageHeading
              icon={workItemIcon("RISK_CONTROL_VERIFICATION")}
              heading="Risk control verifications"
            />
          }
          actions={[
            <ActionButton
              key="clearFilter"
              tooltip="Clear filters"
              icon={clearIcon()}
              onClick={clearFilter}
              data-cy="clear-filters-button"
            />,
          ]}
        />
      </HeaderBar>
      <RiskControlVerificationFilters
        filter={filter}
        updateFilter={updateFilter}
      />
      <Container fluid className={classes.contents}>
        <RiskControlVerificationListing
          history={history}
          filter={filter}
          clearFilter={clearFilter}
          sortBy={sortBy}
          updateSort={setSortBy}
        />
      </Container>
    </div>
  );
};

RiskControlVerificationsListingPage.propTypes = {
  history: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object,
};

RiskControlVerificationsListingPage.defaultProps = {
  loggedInUser: null,
};

const mapStateToProps = (state) => ({
  loggedInUser: getLoggedInUser(state),
});

export default connect(mapStateToProps)(RiskControlVerificationsListingPage);
